import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MapItemComponent } from '@ui/shared/util-map';
import type { CultureMapItemModel } from '../../entities/culture-map-item.model';
import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { CultureMapItemFacilityDetailComponent } from './culture-map-item-facility-detail.component';
import { CultureMapItemOfferingDetailComponent } from './culture-map-item-offering-detail.component';
import { CultureMapFacilityItemModel } from '../../entities/culture-map-facility-item.model';
import { CultureMapOfferingItemModel } from '../../entities/culture-map-offering-item.model';

@Component({
    selector: 'ui-culture-map-item-details',
    imports: [
        DetailViewModule,
        CultureMapItemFacilityDetailComponent,
        CultureMapItemOfferingDetailComponent,
    ],
    templateUrl: './culture-map-item-details.component.html',
    styleUrl: './culture-map-item-details.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CultureMapItemDetailsComponent implements MapItemComponent<CultureMapItemModel> {
    public readonly mapItemTriggeredById = output<CultureMapItemModel>();

    public mapItem = input<CultureMapItemModel | undefined>();

    public get offering(): CultureMapOfferingItemModel | undefined {
        const mapItem = this.mapItem();

        return mapItem instanceof CultureMapOfferingItemModel ? mapItem : undefined;
    }

    public get facility(): CultureMapFacilityItemModel | undefined {
        const mapItem = this.mapItem();

        return mapItem instanceof CultureMapFacilityItemModel ? mapItem : undefined;
    }

    public triggerMapItemById(linkedItem: CultureMapItemModel): void {
        this.mapItemTriggeredById.emit(linkedItem);
    }
}
